import React, { useEffect, useState } from "react";
import "./Accident.css";
import { logHistory } from "../../utils/historyLogger";

function Accident() {
  const [accidents, setAccidents] = useState([]);
  const role = localStorage.getItem("role");
  const canEdit = role === "admin" || role === "superadmin";
  const canDelete = role === "superadmin";
  // Any logged-in role (user, admin, superadmin) can add data now.
  const canAdd = role === "user" || role === "admin" || role === "superadmin";

  const [search, setSearch] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [companyStatus, setCompanyStatus] = useState("Company");
  const [companyName, setCompanyName] = useState("");
  const [epf, setEpf] = useState("");
  const [nic, setNic] = useState("");
  const [department, setDepartment] = useState("");
  const [category, setCategory] = useState("");
  const [workCarriedOut, setWorkCarriedOut] = useState("");
  const [actionTaken, setActionTaken] = useState("");
  const [incidentType, setIncidentType] = useState("");
  const [name, setName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [gender, setGender] = useState("Male");
  const [description, setDescription] = useState("");
  const [remark, setRemark] = useState("");

  useEffect(() => {
    fetchAccidents();
  }, []);

  const fetchAccidents = async () => {
    try {
      const response = await fetch("https://hrpsc.swisstekaluminium.com/api/accidents");
      const data = await response.json();
      setAccidents(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
    }
  };

  const clearForm = () => {
    setDate("");
    setTime("");
    setCompanyStatus("Company");
    setCompanyName("");
    setEpf("");
    setNic("");
    setDepartment("");
    setCategory("");
    setWorkCarriedOut("");
    setActionTaken("");
    setIncidentType("");
    setName("");
    setContactNumber("");
    setGender("Male");
    setDescription("");
    setRemark("");
    setEditingId(null);
  };
    const handleSubmit = async () => {
    try {
      if (!epf || !nic) {
        alert("EPF and NIC are required");
        return;
      }

      const newAccident = {
        date,
        time,
        companyStatus,
        companyName,
        epf,
        nic,
        department,
        category,
        workCarriedOut,
        actionTaken,
        incidentType,
        name,
        contactNumber,
        gender,
        description,
        remark,
      };

      let response;

      if (editingId) {
        response = await fetch(
          `https://hrpsc.swisstekaluminium.com/api/accidents/${editingId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newAccident),
          }
        );

        if (!response.ok) {
          throw new Error("Update failed");
        }

        await logHistory(
          "Accidents",
          "Updated Accident Record",
          "Accident record updated"
        );

        alert("Updated Successfully");
      } else {
        response = await fetch("https://hrpsc.swisstekaluminium.com/api/accidents", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newAccident),
        });

        if (!response.ok) {
          throw new Error("Save failed");
        }

        await logHistory(
          "Accidents",
          "Added Accident Record",
          "Accident record added"
        );

        alert("Added Successfully");
      }

      fetchAccidents();
      clearForm();
    } catch (error) {
      console.log(error);
      alert("Error Saving Accident");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this accident record?")) return;

    try {
      const response = await fetch(
        `https://hrpsc.swisstekaluminium.com/api/accidents/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Delete failed");
      }

      await logHistory(
        "Accidents",
        "Deleted Accident Record",
        "Accident record deleted"
      );

      fetchAccidents();
      alert("Deleted Successfully");
    } catch (error) {
      console.log(error);
      alert("Delete Failed");
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setDate(item.date || "");
    setTime(item.time || "");
    setCompanyStatus(item.companyStatus || "Company");
    setCompanyName(item.companyName || "");
    setEpf(item.epf || "");
    setNic(item.nic || "");
    setDepartment(item.department || "");
    setCategory(item.category || "");
    setWorkCarriedOut(item.workCarriedOut || "");
    setActionTaken(item.actionTaken || "");
    setIncidentType(item.incidentType || "");
    setName(item.name || "");
    setContactNumber(item.contactNumber || "");
    setGender(item.gender || "Male");
    setDescription(item.description || "");
    setRemark(item.remark || "");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
    const downloadCSVReport = () => {
    if (accidents.length === 0) {
      alert("No accident data to download");
      return;
    }

    const headers = Object.keys(accidents[0]);

    const rows = accidents.map((item) =>
      headers
        .map((field) => `"${String(item[field] ?? "").replace(/"/g, '""')}"`)
        .join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "accident_report.csv";
    link.click();

    URL.revokeObjectURL(url);
  };

  const filteredData = accidents.filter(
    (item) =>
      item.name?.toLowerCase().includes(search.toLowerCase()) ||
      item.epf?.toLowerCase().includes(search.toLowerCase()) ||
      item.nic?.toLowerCase().includes(search.toLowerCase()) ||
      item.companyName?.toLowerCase().includes(search.toLowerCase())
  );

  const totalRecords = accidents.length;

  const companyCount = accidents.filter(
    (item) => item.companyStatus === "Company"
  ).length;

  const nonCompanyCount = accidents.filter(
    (item) => item.companyStatus === "Non Company"
  ).length;

  const maleCount = accidents.filter((item) => item.gender === "Male").length;

  const femaleCount = accidents.filter(
    (item) => item.gender === "Female"
  ).length;

  return (
    <div className="accident-page">
      <h1 className="page-title">Accident Records</h1>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>Total Records</h3>
          <h1>{totalRecords}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Company</h3>
          <h1>{companyCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Non Company</h3>
          <h1>{nonCompanyCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Male</h3>
          <h1>{maleCount}</h1>
        </div>

        <div className="dashboard-card">
          <h3>Female</h3>
          <h1>{femaleCount}</h1>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search Accident"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <button className="clear-btn" onClick={() => setSearch("")}>
          Clear
        </button>

        {/* Download available to every role - user downloads their own
            assigned-interface data, admin/superadmin download any interface */}
        <button className="add-btn" onClick={downloadCSVReport}>
          Download Report
        </button>
      </div>

      {/* Add form: user, admin, and superadmin can all add data now.
          The same form is reused for editing an existing record
          (editingId gets set by handleEdit). */}
      {(canAdd || editingId) && (
        <div className="form-container">
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />

          <input type="time" value={time} onChange={(e) => setTime(e.target.value)} />

          <select
            value={companyStatus}
            onChange={(e) => setCompanyStatus(e.target.value)}
          >
            <option>Company</option>
            <option>Non Company</option>
          </select>

          <input
            type="text"
            placeholder="Company Name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />

          <input
            type="text"
            placeholder="EPF *"
            value={epf}
            onChange={(e) => setEpf(e.target.value)}
          />

          <input
            type="text"
            placeholder="NIC *"
            value={nic}
            onChange={(e) => setNic(e.target.value)}
          />

          <input
            type="text"
            placeholder="Department"
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          />

          <input
            type="text"
            placeholder="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />

          <input
            type="text"
            placeholder="Work Carried Out"
            value={workCarriedOut}
            onChange={(e) => setWorkCarriedOut(e.target.value)}
          />

          <input
            type="text"
            placeholder="Action Taken"
            value={actionTaken}
            onChange={(e) => setActionTaken(e.target.value)}
          />

          <input
            type="text"
            placeholder="Incident Type"
            value={incidentType}
            onChange={(e) => setIncidentType(e.target.value)}
          />

          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <input
            type="text"
            placeholder="Contact Number"
            value={contactNumber}
            onChange={(e) => setContactNumber(e.target.value)}
          />

          <select value={gender} onChange={(e) => setGender(e.target.value)}>
            <option>Male</option>
            <option>Female</option>
          </select>

          <input
            type="text"
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          <input
            type="text"
            placeholder="Remark"
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />

          <button className="add-btn" onClick={handleSubmit}>
            {editingId ? "Update Record" : "Add Record"}
          </button>

          <button className="clear-btn" onClick={clearForm}>
            Clear Form
          </button>
        </div>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Company</th>
              <th>EPF</th>
              <th>NIC</th>
              <th>Department</th>
              <th>Category</th>
              <th>Work</th>
              <th>Action Taken</th>
              <th>Incident</th>
              <th>Name</th>
              <th>Contact</th>
              <th>Gender</th>
              <th>Description</th>
              <th>Remark</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.map((item) => (
              <tr key={item.id}>
                <td>{item.date}</td>
                <td>{item.time}</td>
                <td>{item.companyStatus}</td>
                <td>{item.epf}</td>
                <td>{item.nic}</td>
                <td>{item.department}</td>
                <td>{item.category}</td>
                <td>{item.workCarriedOut}</td>
                <td>{item.actionTaken}</td>
                <td>{item.incidentType}</td>
                <td>{item.name}</td>
                <td>{item.contactNumber}</td>
                <td>{item.gender}</td>
                <td>{item.description}</td>
                <td>{item.remark}</td>

                <td>
                  {canEdit && (
                    <button
                      className="edit-btn"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                  )}

                  {canDelete && (
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Accident;